
























import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "upgrade-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderUpgradeControl.vue"),
    "first-steps-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderFirstStepsControl.vue"),
    "docs-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderDocsControl.vue"),
    "quick-actions": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderQuickActions.vue")
  }
})
export default class AdminContentHeader extends Vue {
  public get previousRoute() {
    return this.$store.getters["ui/previousRoute"];
  }
}
